<script>
  import ModalRegulation from '@/components/templates/ModalRegulation'
  export default {
    name: 'Footer',
    methods: {
      open: function() {
        this.$store.commit('toggleModalRegulation', true);
      },
      testDate7th: function() {
        this.$store.commit('testDate7th');
        this.$store.dispatch('doSave');
      }
    }
  }
</script>

<template lang="pug">
  .footer
    .footer__caution
      |※データが引き継がれない場合がありますので、
      br.brNoto
      |毎回同じブラウザからお楽しみください。
    .footer__regulation(
      @click = 'open'
      )
      |参加規約
    .footer__copyright
      |Copyright 住友生命保険相互会社
</template>

<style lang="scss">
  .footer {
    display: flex;
    @include l-more-than-mobile {
      flex-direction: row-reverse;
      justify-content: space-between;
      align-items: center;
    }
    @include l-mobile {
      flex-direction: column;
      align-items: center;
    }
    &__caution {
      @include l-more-than-mobile {
        display: none;
      }
      @include l-mobile {
        text-align: center;
        @include fontSize(10);
        color: $base-color;
        letter-spacing: 0.58px;
        margin-bottom: 20px;
      }
    }
    &__regulation {
      width: 100px;
      height: 33px;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #fff;
      border-radius: 16.5px;
      color: #fff;
      @include fontSize(13);
      text-decoration: none;
      @include l-more-than-mobile {
        cursor: pointer;
      }
      @include l-mobile {
        margin-bottom: 17px;
      }
    }
    &__copyright {
      color: #fff;
      @include fontSize(12);
    }
  }
</style>
